module.exports = __webpack_public_path__ + "media/images/browsers/android-browser-5ee3887c3b9dd3159333e52093f92345.svg";